/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Initial money transfer translations
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.2.0
 */

import { IMoneyTransferTranslation } from '../../types/wizards/moneyTransfer';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initMoneyTransferTranslation: IMoneyTransferTranslation = {
    ...initWizardPropsTranslation,
    accountSelectPlaceholder: '',
    hintTextConflicts: '',
    hintTextFirstStep: '',
    labelAccountFrom: '',
    labelAccountTo: '',
    modalError: {
        message: '',
        error: '',
    },
    steps: {
        TransferAccountWizardStep: '',
        TransferFinalWizardStep: '',
    },
    transferAmount: {
        label: '',
        hint: '',
    },
    modalSummaryError: {
        message: '',
        title: '',
    },
};
